import { Record } from 'immutable';
import { createMember } from '../members/member';

export const Member = new Record({
    isNew: true,
    isPending: false,
    error: null,
    leader: false,
    team_id: null,
    user_id: null,
    member: null
});

export function createExtendedMember(data) {
  return new Member({
    isNew: false,
    leader: data.leader,
    team_id: data.team_id,
    user_id: data.user_id,
    member: createMember({id: data.user_id, ...data.member})
  });
}
